import * as React from 'react';
import Stack from '@mui/material/Stack';
import RestrictedAccess from '../../components/RestrictedAccess';
import catalogApiClient from '../../services/catalogapi';
import { AxiosResponse } from 'axios';
import { alertError, alertSuccess } from '../../slices/global/alertSlice';
import { useAppDispatch } from '../../hooks';
import { Button, List, ListItem, ListItemText, TextField, Typography } from '@mui/material';
import { GenerationResponse } from './model';

export default function GenerateFitment() {
  const [skus, setSkus] = React.useState<string>('');
  const [errors, setErrors] = React.useState<string[]>([]);
  const dispatch = useAppDispatch();

  const handleSubmit = () => {
    setErrors([]);
    if (!skus) {
      return;
    }
    const controller = new AbortController();

    let message = skus.split(',').map((x) => x.trim());
    (async () => {
      await catalogApiClient
        .post('api/v1/fitment/generate', message, {
          signal: controller.signal,
        })
        .then((response: AxiosResponse<GenerationResponse>) => {
          setErrors(response.data.failures);
          dispatch(alertSuccess(`${response.data.successes.length} skus triggered for generation`));
          setSkus('');
        })
        .catch(function (err) {
          if (err.message !== 'canceled') {
            dispatch(alertError(`Failed to send skus for generation. Reason: ${err}`));
          }
        });
    })();
  };

  return (
    <RestrictedAccess type="UI-Access" value="Generate Fitment">
      <Stack spacing={2}>
        <TextField
          multiline
          minRows={4}
          maxRows={6}
          id="sku"
          value={skus}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setSkus(event.target.value);
          }}
          label="Skus"
        />
        <Button color="success" variant="contained" onClick={handleSubmit}>
          Submit for Generation
        </Button>
        <Typography sx={{ mt: 4, mb: 2 }} variant="h6" component="div">
          Errors:
        </Typography>
        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
          {errors.map((value) => (
            <ListItem key={value} disableGutters>
              <ListItemText primary={`${value}`} />
            </ListItem>
          ))}
        </List>
      </Stack>
    </RestrictedAccess>
  );
}
